import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IActiveJobOffertsProps } from '../components/active-job-offerts/active-job-offerts';
import { JobOffertItemModel } from './job-offert-item-model';
import { IJobOffertItemProps } from '../components/active-job-offerts/job-offert-item/job-offert-item';

export class ActiveJobOffertsModel extends ContentItem {
  get headerValue(): string {
    return get(this._config, 'elements.header_value.value', '');
  }

  get applyButtonText(): string {
    return get(this._config, 'elements.apply_button_text.value', '');
  }

  get jobOfferts(): IJobOffertItemProps[] | null {
    const nodes = get(this._config, 'elements.job_offerts.value', []);
    const modeledJobOfferts = nodes
      ? nodes.map((article: IJobOffertItem) =>
          JobOffertItemModel.create(article)
        )
      : null;

    return modeledJobOfferts;
  }

  public static create(data: IActiveJobOfferts): IActiveJobOffertsProps {
    const {
      headerValue,
      applyButtonText,
      jobOfferts
    } = new ActiveJobOffertsModel(data);

    return {
      headerValue,
      applyButtonText,
      jobOfferts
    };
  }
}
